import { render, staticRenderFns } from "./EntityControllerMultiple.vue?vue&type=template&id=cc4ab270&lang=pug"
import script from "./EntityControllerMultiple.vue?vue&type=script&lang=js"
export * from "./EntityControllerMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports